import { c as _c } from "react/compiler-runtime";
import { cx } from 'class-variance-authority';
import Icon from '~/components/primitives/Icon';

/** Five stars, filled up to `rating`. Read-only by default; pass `onChange` to
 * make each star a button, which is how the review form collects a score. */
const ReviewStars: React.FC<{
  rating: number;
  onChange?: (rating: number) => void;
}> = props => {
  const $ = _c(8);
  let t0;
  if ($[0] !== props.onChange || $[1] !== props.rating) {
    t0 = !props.onChange && <span className="sr-only">{props.rating}/5</span>;
    $[0] = props.onChange;
    $[1] = props.rating;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== props) {
    t1 = Array.from({
      length: 5
    }, (_, index) => {
      const starNumber = index + 1;
      const star = <Icon aria-hidden={true} name="star" className={cx("h-4 w-4 fill-current", starNumber <= props.rating ? "text-yellow" : "text-gray-300", props.onChange && "cursor-pointer transition-colors hover:text-yellow-300")} />;
      if (!props.onChange) {
        return <span key={starNumber}>{star}</span>;
      }
      return <button key={starNumber} type="button" aria-pressed={starNumber === props.rating} onClick={() => props.onChange?.(starNumber)}><span className="sr-only">{starNumber}/5</span>{star}</button>;
    });
    $[3] = props;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== t0 || $[6] !== t1) {
    t2 = <>{t0}{t1}</>;
    $[5] = t0;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
};
export default ReviewStars;